module.exports = __webpack_public_path__ + "static/img/04-人大附中通州校区1.7a15e35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/04-人大附中通州校区1.png
// module id = dXsO
// module chunks = 0